import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { DotsHorizontal } from "../icons";
import { TextBase } from "../internal/TextBase";
import SocialButton from '../SocialButton';
import style from './SocialButtons.css';
var cx = classNames.bind(style);
var ACTIONS = [['onClickTinkoff', 'tinkoff'], ['onClickVK', 'vk'], ['onClickGoogle', 'google'], ['onClickYandex', 'yandex'], ['onClickFB', 'fb'], ['onClickInstagram', 'instagram']];

var isVisible = function isVisible(visible) {
  return (visible === 0 || visible) && visible < ACTIONS.length;
};

var SocialButtons = function SocialButtons(props) {
  var disabled = props.disabled,
      _props$propsByNetwork = props.propsByNetwork,
      propsByNetwork = _props$propsByNetwork === void 0 ? defaultPropObject : _props$propsByNetwork,
      text = props.text,
      _props$textProps = props.textProps,
      textProps = _props$textProps === void 0 ? defaultPropObject : _props$textProps,
      title = props.title,
      _props$titleProps = props.titleProps,
      titleProps = _props$titleProps === void 0 ? defaultPropObject : _props$titleProps,
      visible = props.visible,
      _props$classes = props.classes,
      classes = _props$classes === void 0 ? defaultPropObject : _props$classes;
  var withVisible = isVisible(visible);

  var _useState = useState(!withVisible),
      _useState2 = _slicedToArray(_useState, 2),
      allVisible = _useState2[0],
      setAllVisible = _useState2[1];

  var handleShowAll = useCallback(function () {
    setAllVisible(!allVisible);
  }, [allVisible]);
  useEffect(function () {
    setAllVisible(!withVisible); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', classes.root)
  }, title && /*#__PURE__*/React.createElement("div", _extends({
    className: cx('Title')
  }, titleProps), title), text && /*#__PURE__*/React.createElement("div", _extends({
    className: cx('Text')
  }, textProps), /*#__PURE__*/React.createElement(TextBase, {
    size: "l"
  }, text)), /*#__PURE__*/React.createElement("div", {
    className: cx('Buttons', classes.buttons)
  }, ACTIONS.map(function (_ref, i) {
    var _ref2 = _slicedToArray(_ref, 2),
        action = _ref2[0],
        network = _ref2[1];

    return props[action] && (!withVisible || allVisible || visible && i < visible) && /*#__PURE__*/React.createElement("span", {
      key: action,
      className: cx('Button')
    }, /*#__PURE__*/React.createElement(SocialButton, _extends({
      disabled: disabled,
      network: network,
      onClick: props[action]
    }, propsByNetwork.network || {})));
  }), withVisible && !allVisible && /*#__PURE__*/React.createElement("button", {
    className: cx('MoreHoriz'),
    disabled: disabled,
    onClick: handleShowAll,
    type: "button"
  }, /*#__PURE__*/React.createElement(DotsHorizontal, {
    size: "md"
  }))));
};

export default SocialButtons;